
export const system = (() => {
	const u = navigator.userAgent;
	const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
	const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
	if (isIOS) {
		return 'IPH'
	}else if (isAndroid) {
		return 'ADR'
	}else{
		return 'pc'
	}
})();

export const isWechat = /MicroMessenger/i.test(navigator.userAgent);




// WEBPACK FOOTER //
// ./src/common/utils/plantform.js